import React from 'react';
import { IParticipantLineMap } from 'src/types/OrderHistory';
import { GroupOrderLine } from 'src/common/Order/OrderReceipt/GroupOrderLine';
import { showDinerBorderBottom } from 'src/common/Order/utils';

export interface IGroupOrderLinesProps {
  hostLine: IParticipantLineMap;
  participantLines: IParticipantLineMap[];
}

export function GroupOrderLines({
  hostLine,
  participantLines,
}: IGroupOrderLinesProps): JSX.Element {
  return (
    <>
      <GroupOrderLine
        dinerName={hostLine.dinerName}
        isHost={hostLine.isHost}
        items={hostLine.items}
        showBorderBottom={showDinerBorderBottom(
          hostLine.isHost,
          participantLines.length
        )}
      />
      {participantLines.map((participantLine, idx) => (
        <GroupOrderLine
          key={participantLine.dinerId}
          dinerName={participantLine.dinerName}
          isHost={participantLine.isHost}
          items={participantLine.items}
          showBorderBottom={showDinerBorderBottom(
            participantLine.isHost,
            participantLines.length,
            idx
          )}
        />
      ))}
    </>
  );
}
